// Must match the `gap` on .marquee-track — the loop distance is derived from it.
export const ROW_GAP = 4;
// Safety valve so a tall viewport against a tiny pool cannot explode the DOM.
export const MAX_RENDERED_ROWS = 400;

/**
 * Works out how far the track scrolls per cycle and how many copies of the list
 * must exist for that scroll to look continuous.
 *
 * The track is one flat, evenly-gapped column, so row i sits at exactly
 * i * (rowHeight + ROW_GAP) — including across the seam between copies. Scrolling
 * by exactly one copy therefore lands every row where its twin was, which is what
 * makes the loop invisible. The copy count must leave enough content below the
 * fold to still cover the viewport at the *end* of a cycle, otherwise the list
 * drains and you see it empty out before it snaps back.
 */
export const computeMarqueeLayout = ({itemCount, rowHeight, viewportHeight}) => {
    if (itemCount <= 0 || rowHeight <= 0) return {loopDistance: 0, copies: 1};

    const loopDistance = itemCount * (rowHeight + ROW_GAP);
    const needed = 1 + Math.ceil((viewportHeight + ROW_GAP) / loopDistance);
    const affordable = Math.floor(MAX_RENDERED_ROWS / itemCount) || 2;

    return {loopDistance, copies: Math.max(2, Math.min(needed, affordable))};
};
